module.exports = __webpack_public_path__ + "fonts/payback_script.a0e2acfb.eot";